import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	auth: 'mw/auth',
	auth__logout_idm: 'mw/auth/logout_idm',
};

export const authApi = createApi({
	reducerPath: 'mw/authApi',

	endpoints: (builder) => ({
		auth: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/auth?${qs.stringify(body)}`,
			}),
			providesTags: [tags.auth],
		}),
		notAuth: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/auth/not_auth?${qs.stringify(body)}`,
			}),
			providesTags: [tags.auth],
		}),
		authLogoutIdm: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/auth/logout_idm?${qs.stringify(body)}`,
			}),
			providesTags: [tags.auth__logout_idm],
		}),
	}),
});

export const {
	auth,
	notAuth,
	authLogoutIdm,
} = authApi.endpoints;

export default authApi;